import React from 'react'
import s from './teacher-reviews.module.scss'
import { IconStar, IconStarFilled } from '@tabler/icons-react'
import Rating from 'react-rating'
import { TextCollapse } from '@shared/ui/text-collapse/text-collapse'
import { format } from 'date-fns';
import { ru } from 'date-fns/locale';
import { getCDNPath } from '@utils/lib/getCDNpath'

export const Review = ({review}) => {
	return (
		<div className={s.reviewCard}>
				<div className={s.cardHeader}>
					<div className={s.avatarWrapper}>
						<img
							src={
								(review?.user?.avatar || review?.user_avatar)
									? getCDNPath(review?.user?.avatar || review?.user_avatar)
									: "https://storage.yandexcloud.net/sozvuchno-static/images/default_avatar.png"
							}
							alt=""
							className={s.avatarImage}
						/>
					</div>
					<div className={s.content}>
						<span className={s.name}>
							{review?.user?.name || review?.user_name}
						</span>
						<span className={s.createdAt}>
							{format(review?.created_at, "dd MMMM yyyy", { locale: ru })}
						</span>
					</div>
					<Rating className={s.reviewStars} fullSymbol={<IconStarFilled size={18} className={s.star}/>} emptySymbol={<IconStar size={18} className={s.star}/>} readonly={true} initialRating={review.feedback_rating || review?.rating}/>
				</div>
				<TextCollapse className={s.reviewText} maxHeight={180}>{review?.feedback_message || review?.message}</TextCollapse>
		</div>
	)
}
